/**
 * @name LoaderOrderer
 * @interface
 */

/**
 * Gives "staggered" loader index
 * @implements LoaderOrderer
 */
export class LeastLoadedLoaderOrderer {
  /**
   * Gives next index to load
   * @param {Array.<{loader:{complete,loadedPages},loading:boolean}>} graphs
   * @return number|undefined
   */
  next(graphs) {
    let candidate;
    let result;
    let count = 0;
    graphs.forEach((graph, i) => {
      const loader = graph.loader;
      if (!graph.loading || loader.complete || loader.error) {
        return;
      }
      if (loader.outstandingPages) {
        count += loader.outstandingPages;
        return;
      }
      if (!candidate || loader.requestedPages < candidate.requestedPages) {
        candidate = loader;
        result = i;
      }
    });
    return count < 6 ? result : undefined;
  }
}

export default LeastLoadedLoaderOrderer;
